import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const avantages = [
  { text: "Réponse rapide d'un vrai technicien" },
  { text: "Estimation avant tout déplacement" },
  { text: "Aucun rendez-vous à fixer pour commencer" },
  { text: "Toutes marques de volets et stores" },
];

const etapes = [
  {
    num: 1,
    titre: "Filmez le problème",
    desc: "Une courte vidéo de votre volet ou store.",
  },
  {
    num: 2,
    titre: "Envoyez-la sur WhatsApp",
    desc: "En un clic, depuis votre téléphone.",
  },
  {
    num: 3,
    titre: "Recevez votre diagnostic",
    desc: "Premier avis + estimation, gratuitement.",
  },
];

export default function DiagnosticVideo() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
          {/* Colonne gauche */}
          <div className="flex flex-col items-center">
            {/* Pastille */}
            <div className="inline-flex items-center gap-2 bg-[#E6F7F5] text-[#0F6E56] px-4 py-2 rounded-full text-sm font-semibold mb-5 w-fit">
              <i className="ri-check-line text-brand-cyan"></i>
              100% gratuit & sans engagement
            </div>

            {/* Titre */}
            <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-4">
              <strong className="text-brand-blue">Diagnostic vidéo</strong> gratuit
            </h2>

            {/* Paragraphe */}
            <p className="text-brand-text text-base leading-relaxed mb-6">
              Filmez votre volet ou store qui pose problème, envoyez-nous la vidéo : nos techniciens vous répondent avec un premier diagnostic et une estimation, sans déplacement.
            </p>

            {/* Avantages */}
            <div className="space-y-3 mb-8">
              {avantages.map((a) => (
                <div key={a.text} className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center shrink-0 rounded-full bg-[#E6F7F5] mt-0.5">
                    <i className="ri-check-line text-brand-cyan text-sm"></i>
                  </div>
                  <p className="text-brand-text text-sm leading-relaxed">{a.text}</p>
                </div>
              ))}
            </div>

            {/* Bouton WhatsApp */}
            <a
              href="https://wa.me/33745883392"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-[#25D366] text-white px-8 py-4 rounded-full font-semibold text-base hover:bg-[#25D366]/90 transition-all duration-200 btn-hover-effect w-full sm:w-auto text-center overflow-hidden justify-center"
            >
              <span className="btn-icon-wrap"><i className="ri-whatsapp-line text-xl"></i></span>
              Envoyer ma vidéo sur WhatsApp
            </a>

            {/* Numéro alternatif */}
            <p className="text-[#6E869C] text-sm">
              ou appelez le{" "}
              <a href="tel:0374473240" className="text-brand-cyan font-semibold hover:underline">
                03 74 47 32 40
              </a>
            </p>
          </div>

          {/* Colonne droite */}
          <div className="bg-brand-blue rounded-xl p-6 md:p-8 text-white flex flex-col">
            {/* Image */}
            <div className="rounded-lg overflow-hidden mb-6">
              <ImagePlaceholder
                src="https://readdy.ai/api/search-image?query=A%20homeowner%20filming%20a%20broken%20white%20roller%20shutter%20with%20their%20smartphone%20in%20a%20bright%20modern%20French%20house%20interior%2C%20the%20person%20holds%20the%20phone%20at%20arm%20length%20capturing%20the%20shutter%20mechanism%2C%20natural%20daylight%20streaming%20through%20windows%2C%20clean%20interior%20background%2C%20realistic%20photography%2C%20warm%20and%20professional%20tone%2C%20service-oriented%20scene&width=700&height=150&seq=diag-video&orientation=landscape"
                alt="Diagnostic vidéo d'un volet roulant cassé par WhatsApp à Strasbourg"
                className="w-full h-[150px] object-cover"
                loading="lazy"
                width={700}
                height={150}
              />
            </div>

            <h3 className="text-lg font-bold mb-5">Comment ça marche</h3>

            <div className="space-y-5">
              {etapes.map((e) => (
                <div key={e.num} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0 rounded-full bg-brand-cyan text-white font-bold text-sm">
                    {e.num}
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm">{e.titre}</p>
                    <p className="text-white/70 text-sm leading-relaxed">{e.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}